import { render } from "./IconCheckBig.vue?vue&type=template&id=08cc5580"
import script from "./IconCheckBig.vue?vue&type=script&lang=js"
export * from "./IconCheckBig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__